import React from 'react';
import { useController } from 'react-hook-form';

// tools
import renderHtmlContent from '../../../../helpers/renderHtmlContent';

// components
import FormFieldError from '../FormFieldError';

const RadioButtons = ({ name, control, rules, label, options = [], ...props }) => {
    const {
        field,
        fieldState: { error }
    } = useController({
        name,
        control,
        rules
    });

    return (
        <div className="FormField FormField--radio">
            {label && <label className="FormField__legend">{renderHtmlContent(label)}</label>}
            <div className="FormField__radioGroup">
                {options.map((option) => (
                    <label key={option.value} className="FormField__radioItem">
                        <input
                            {...field}
                            {...props}
                            type="radio"
                            value={option.value}
                            checked={field.value === option.value}
                        />
                        <span className="FormField__radioLabel">{renderHtmlContent(option.label)}</span>
                    </label>
                ))}
            </div>
            <FormFieldError error={error} />
        </div>
    );
};

export default RadioButtons;